{
  "contentMenu": {
    "title": "Tittel",
    "subTitle": "Mellomtittel",
    "bodyText": "Brødtekst",
    "vignette": "Vignett",
    "preamble": "Ingress",
    "tvListing": "Tablåinfo",
    "unorderedList": "Liste",
    "orderedList": "Punktliste",
    "searchImages": "Søk bilder",
    "factboxes": "Søk faktabokser"
  },
  "numberOfChars": "Antall tegn",
  "spelling": {
    "noSuggestions": "Ingen forslag",
    "loading": "Henter forslag..."
  },
  "factbox": {
    "headerTitle": "Rediger originalen",
    "modifiedLabel": "Originalen er fra",
    "createdLabel": "Opprettet",
    "lastModifiedLabel": "Sist endret",
    "footerTitle": "Endringer i faktaboksteksten gjelder kun for denne artikkelen",
    "factboxNewTitle": "Fakta",
    "addSingleLabel": "Opprett faktaboks"
  },
  "image": {
    "captionLabel": "Tekst",
    "bylineLabel": "Bild"
  },
  "footer": {
    "words": "Ord",
    "numberOfWords": "Antall ord: artikkel (totalt)",
    "chars": "Tegn",
    "numberOfChars": "Antall tegn: artikkel (totalt)",
    "language": "Artikkelspråk",
    "selection": "Merking",
    "selectionHint": "Teller merket tekst",
    "selectedWords": "Antall merkede ord",
    "selectedChars": "Antall merkede tegn"
  },
  "goToLatestVersion": "Gå til siste versjon",
  "goToLatestVersionShort": "Siste",
  "embargoActive": "Kan ikke publiseres direkte — embargo gjelder til {{time}}",
  "embargoCheckUnavailable": "Kan ikke verifisere embargo. Prøv igjen.",
  "addRoleInfo": {
    "editorial": "Legg til redaksjonell informasjon",
    "internal": "Legg til intern informasjon"
  },
  "removeInfoConfirm": "Er du sikker på at du vil slette informasjonen?",
  "changeType": "Endre type",
  "changeTypeConfirm": "Er du sikker på at du vil endre informasjonstypen?",
  "derivedFromTimelessLink": "tidløs",
  "derivedFromArticleLink": "artikkel",
  "derivedFromConnector": "og",
  "derivedFromPlanningLink": "plan"
}
